import React, { useState } from "react";
import StarRatingComponent from "react-star-rating-component";

import { s360ConfigService } from "../../Services/S360Config";

function MessageA79(props) {
  const [a79State, setA79State] = useState({ rating: 0, prevRating: 0 });
  // const messageRef = createRef();

  const onStarClick = (nextValue) => {
    const ratingEnum = (value) => {
      switch (value) {
        case 1:
          return "Worst";
        case 2:
          return "Bad";
        case 3:
          return "Ok";
        case 4:
          return "Good";
        case 5:
          return "Excellent";
        default:
          return "Excellent";
      }
    };

    setA79State(prev => ({ ...prev, rating: nextValue, prevRating: nextValue }));

    props.actions.sendMessage(ratingEnum(nextValue));
  }

  const onStarHover = (e) => {
    console.log(e);
    setA79State(prev => ({ ...prev, rating: e }));
  }

  const onStarHoverOut = () => {
    setA79State(prev => ({ ...prev, rating: a79State.prevRating }));
  }

  const messageBoxStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA79Box;
  };

  const { rating } = a79State;

  // 1 - Worst
  // 2 - Bad
  // 3 - Ok
  // 4 - Good
  // 5 - Excelent

  return (
    <div className="s360-message-cotainer-received">
      <div
        className="s360-message-box-custom-a14-received"
        style={messageBoxStyle()}
      >
        <h5 style={{ fontWeight: 700 }}>Please share your experience!</h5>
        <div style={{ fontSize: 30 }}>
          <StarRatingComponent
            disabled={props.disabled}
            onStarHover={(e) =>
              onStarHover(e)
            } /* on icon hover handler */
            onStarHoverOut={(e) =>
              onStarHoverOut(e)
            } /* on icon hover out handler */
            name="rate1"
            starCount={5}
            value={rating}
            onStarClick={onStarClick.bind(this)}
            starColor={"yellow"}
            emptyStarColor={"#d3d8f5"}
            size={10}
          />
        </div>
      </div>
    </div>
  );
}

export default MessageA79;
